"use client";

import { useTranslations } from "next-intl";

import { Link } from "../i18n/navigation";

// 全局 Footer：多列导航 + 法律条款（切换语言时保留 locale 前缀）。
export default function SiteFooter() {
  const tc = useTranslations("common");
  const t = useTranslations("footer");

  return (
    <footer className="cgFooter">
      <div className="cgFooterInner">
        <div className="cgFooterBrand">
          <div className="cgFooterLogo">{tc("brandName")}</div>
          <p className="cgFooterTag">{tc("brandTag")}</p>
          <p className="cgFooterDesc">{t("brandDesc")}</p>
          {/* 第三方发布平台徽章：Fazier + Product Hunt，按各自要求站内嵌入 */}
          <div className="cgFooterBadge">
            <a
              href="https://fazier.com/launches/www.clipglobeworld.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&theme=light"
                width={250}
                alt="Featured on Fazier"
              />
            </a>
            <a
              href="https://www.producthunt.com/products/clipglobe?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-clipglobe"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                alt="ClipGlobe - Turn any video into multilingual subtitles and dubbing | Product Hunt"
                width={250}
                height={54}
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1273605&theme=light&t=1791529799484"
              />
            </a>
          </div>
        </div>

        <div className="cgFooterCols">
          <div className="cgFooterCol">
            <div className="cgFooterColTitle">{t("productTitle")}</div>
            <Link href="/create">{t("startTranslate")}</Link>
            <Link href="/features">{t("features")}</Link>
            <Link href="/pricing">{t("pricing")}</Link>
            <Link href="/billing">{t("myPlan")}</Link>
            <Link href="/history">{t("myWorks")}</Link>
          </div>
          <div className="cgFooterCol">
            <div className="cgFooterColTitle">{t("resourcesTitle")}</div>
            <Link href="/blog">{t("blog")}</Link>
            <Link href="/features">{t("faq")}</Link>
            <Link href="/languages">{t("supportedLanguages")}</Link>
            <Link href="/docs">{t("docs")}</Link>
          </div>
          <div className="cgFooterCol">
            <div className="cgFooterColTitle">{t("companyTitle")}</div>
            <Link href="/about">{t("about")}</Link>
            <Link href="/feedback">{t("contact")}</Link>
            <Link href="/privacy">{t("privacy")}</Link>
            <Link href="/terms">{t("terms")}</Link>
          </div>
        </div>
      </div>

      <div className="cgFooterBottom">
        <span>{t("copyright")}</span>
        <span className="cgFooterContact">
          {t("supportEmail")}
          <a href="mailto:support@clipglobeworld.com">support@clipglobeworld.com</a>
        </span>
      </div>
    </footer>
  );
}
